import React from 'react';
import { AddRoomForm } from '../components/AddRoomForm';
export function AddRoom() {
  const handleSaveRoom = (roomData: any) => {
    // In a real application, this would save the room data to an API
    console.log('Saving room data:', roomData);
    // Navigate back to rooms list
    window.location.href = '/rooms';
  };
  const handleCancel = () => {
    window.location.href = '/rooms';
  };
  return <div data-id="element-10068" data-mp="28p0akxu953ve">
      <AddRoomForm onSave={handleSaveRoom} onCancel={handleCancel} data-id="element-10069" data-mp="28qbdywjsc9lz" />
    </div>;
}